import React from 'react'
import classes from './index.module.scss';
import { Grid } from '@material-ui/core';
import { fixToPersianNumbers } from '../../../../utils/helpers';

const sorts = [
  {
    name: "ارزان‌ترین",
    id: "price,asc"
  },
  {
    name: "گران‌ترین",
    id: "price,desc"
  },
  {
    name: "جدید‌ترین",
    id: "created,desc"
  },
  {
    name: "پرفروش‌ترین",
    id: "created,asc"
  }
]

const SortHeader = (props: any) => {
  return (
    <div className={classes.sortBox} >
      <Grid container>
        <div className='ml-4 d-flex'>
          <img className='ml-1' src="/vitrin/icons/sort.svg" alt="sort" />
          <span>مرتب سازی: </span>
        </div>
        {sorts.map(srt => (<Grid item className="text-center ml-4">
          <p className={classes.link + " " + (props.active == srt.id ? classes.active : "")} onClick={() => props.onChangeSort(srt.id)}>{srt.name}</p>
        </Grid>))}
        <span className='mr-auto d-flex'>{fixToPersianNumbers(`${props?.count}`)} کالا</span>
      </Grid>
    </div>
  )
}

export default SortHeader